import { render, staticRenderFns } from "./BdNotice.vue?vue&type=template&id=52f6ef37&"
import script from "./BdNotice.vue?vue&type=script&lang=js&"
export * from "./BdNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports